import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import PillarArticle from "@/pages/article/PillarArticle";

const pillarSlugs = [
  "usfans-review",
  "usfans-shipping-cost",
  "usfans-warehouse",
  "usfans-coupon",
  "usfans-legit",
  "usfans-safety",
  "usfans-qc",
  "usfans-w2c",
  "usfans-buying-guide",
  "usfans-alternatives",
];

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/usfans-spreadsheet-guide",
    element: <ArticlePage />,
  },
  ...pillarSlugs.map((slug) => ({
    path: `/${slug}`,
    element: <PillarArticle slug={slug} />,
  })),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;